module.exports = __webpack_public_path__ + "img/ar.3ae373fa.png";